// extracted by mini-css-extract-plugin
export default {"root":"Rules_root__8s40V","headings":"Rules_headings__JTabD"};